import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="pwa"
export default class extends Controller {
  static values = {
    serviceWorkerUrl: { type: String, default: "/service-worker.js" },
  };

  connect() {
    this.boundRegister = this.registerServiceWorker.bind(this);
    this.boundMarkDisplayMode = this.markDisplayMode.bind(this);
    this.displayModeQuery = window.matchMedia?.("(display-mode: standalone)");

    this.markDisplayMode();
    this.registerAfterPageLoad();

    this.displayModeQuery?.addEventListener?.("change", this.boundMarkDisplayMode);
  }

  disconnect() {
    this.displayModeQuery?.removeEventListener?.("change", this.boundMarkDisplayMode);
  }

  registerAfterPageLoad() {
    if (document.readyState === "complete") {
      this.registerServiceWorker();
    } else {
      window.addEventListener("load", this.boundRegister, { once: true });
    }
  }

  registerServiceWorker() {
    if (!("serviceWorker" in navigator)) return;
    // Never install a worker in an automated (WebDriver/Selenium) browser. A
    // registered service worker outlives the page that registered it and keeps
    // making background fetches; under the system-test suite those fetches pass
    // through Warden's global test-login queue and intermittently consume the
    // login a concurrent request spec just queued, signing it out at random.
    // Real users (navigator.webdriver is false) are unaffected.
    if (navigator.webdriver) return;

    navigator.serviceWorker.register(this.serviceWorkerUrlValue).catch(() => {
      // The app is still fully usable without an installed worker.
    });
  }

  markDisplayMode() {
    const standalone =
      this.displayModeQuery?.matches ||
      window.navigator.standalone === true;

    document.documentElement.dataset.displayMode = standalone ? "standalone" : "browser";
    this.element.dataset.pwaStandalone = standalone ? "true" : "false";
  }
}
